 import { useGlobalContext } from './Context'
 import './App.css'

import Navbar from './components/Navbar'
 import Search from './components/Search'
 import Meals from './components/Meals'
 import Modal from './components/Modal'
 import Favorites from './components/Favorites'
 import Footer from './components/Footer'
 export default function App() {
   const { showModal, favorites } = useGlobalContext()

   return (
    <>
    <header>
         <Navbar />      
    </header>
<main>
  <hr></hr>

<Search />
<hr></hr>
{favorites.length > 0 && <Favorites />}

<hr></hr>


<Meals />
{showModal && <Modal />}
</main>
<hr></hr>
<footer>
  <Footer />
</footer>

    </>
     
   )
 }